import { createContext, useContext } from "react";

const RosterDashboardSectionContext = createContext<string | null>(null);

export function RosterDashboardSectionProvider({
  sectionId,
  children
}: {
  sectionId: string;
  children: React.ReactNode;
}) {
  return <RosterDashboardSectionContext.Provider value={sectionId}>{children}</RosterDashboardSectionContext.Provider>;
}

export function useRosterDashboardSectionId(): string | null {
  return useContext(RosterDashboardSectionContext);
}
